import React from 'react';

const ResetPasswordSuccess = () => {
  return (
    <div className="mx-auto w-[400px] pb-[200px] pt-[90px] text-center">
      <h1 className="mb-[70px] text-center text-[26px] font-medium text-neutral-700">
        パスワードの再設定
      </h1>

      <div className="mb-10 mt-5 text-xs leading-[1.5] text-neutral-900 [&_p]:mb-0">
        <p>
          ご入力のメールアドレスが登録されている場合は、パスワードを再設定するためのメールをお送りしました。
        </p>
        <p>メールをご確認ください。</p>
      </div>
    </div>
  );
};

export {ResetPasswordSuccess};
